import React from 'react';
import {
  List as RaList, useGetIdentity, TopToolbar, ExportButton,
} from 'react-admin';
import { DateTime } from 'luxon';
import { usePageTitle } from '../../../components/usePageTitle';
import { withPermissions } from '../../../components/hoc/WithPermissions';
import { USER_TYPE } from '../../../constants/statuses';
import { Filter } from './Filter';
import TransactionList from '../Components/transactionsList';

const ListActions = (props) => (
  <TopToolbar>
    <ExportButton {...props} maxResults={10000} />
  </TopToolbar>
);

const List = (props) => {
  usePageTitle(props);
  const { loading: identityLoading } = useGetIdentity();

  if (identityLoading) {
    return null;
  }

  const filterDefValues = {
    'createdAt||$gte': DateTime.now().minus({ days: 30 }).toISODate(),
    'createdAt||$lt': DateTime.now().plus({ days: 1 }).toISODate(),
  };

  return (
    <RaList
      {...props}
      filterDefaultValues={filterDefValues}
      filters={<Filter />}
      bulkActionButtons={false}
      actions={<ListActions {...props} />}
    >
      <TransactionList {...props} />
    </RaList>
  );
};

export default withPermissions(
  List,
  [USER_TYPE.MANAGER, USER_TYPE.WORKER, USER_TYPE.DEVELOPER],
  null,
);
